import { useEffect, useRef } from 'react'

type MenuItem = {
  label: string
  onClick: () => void
  icon: React.ReactNode
  className?: string
}

type MenuProps = {
  setOpen: (open: boolean) => void
  menuItems: MenuItem[]
}

export const Menu = ({ setOpen, menuItems }: MenuProps) => {
  const menuRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      event.stopPropagation()
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setOpen(false)
      }
    }

    window.addEventListener('mousedown', handleClickOutside)
    return () => {
      window.removeEventListener('mousedown', handleClickOutside)
    }
  }, [menuRef, setOpen])

  const menuText = 'text-sm text-gray-700 hover:text-gray-900'
  return (
    <div
      className="absolute right-5 top-10 z-10 mt-2 w-40 divide-y divide-gray-100 rounded-md bg-white shadow-md"
      ref={menuRef}>
      {menuItems.map((item) => (
        <div
          className="flex h-full flex-row items-center px-4 py-2 transition duration-300 ease-in-out hover:bg-gray-100"
          key={item.label}
          onClick={(e) => {
            e.stopPropagation()
            item.onClick()
          }}>
          {item.icon}
          <p className={item.className ? menuText + ' ' + item.className : menuText}>{item.label}</p>
        </div>
      ))}
    </div>
  )
}
